import { API } from '@/shared/api/modules';
import type { GetStaffingRatioRequestDto } from '@/shared/api/modules/staff';
import { queryOptions } from '@tanstack/react-query';

export const getStaffingRatioQueryOptions = (
  params: GetStaffingRatioRequestDto
) =>
  queryOptions({
    queryKey: ['staffing-ratio', params],
    queryFn: async ({ signal }) => {
      const response = await API.staff.getStaffingRatio(params, {
        signal,
      });

      return response;
    },
    enabled: !!params.from && !!params.to,
  });
